import React from "react";

const Electricity = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M17.512 22.018h-.391c-2.746 0-5.493-.023-8.24.014-.786.01-1.09-.589-.732-1.199 3.596-6.098 7.163-12.211 10.737-18.32.027-.046.053-.092.081-.136.205-.32.493-.442.813-.344.34.105.528.372.484.753-.082.707-.186 1.41-.28 2.115l-.939 6.998-.279 2.083h.413c2.81 0 5.622.002 8.433-.002.352-.001.631.091.781.428.122.274.005.504-.13.738-1.293 2.24-2.582 4.483-3.873 6.725L17.75 33.41c-.299.519-.562.672-.945.55-.389-.121-.518-.373-.456-.978.242-2.32.495-4.64.741-6.958l.422-4.006Z"
            fill={fill}
        />
    </svg>
);

export default Electricity;
